import Logo from 'assets/brand/Logo';

function NotFoundLayout() {
  return (
    <div className='min-h-screen w-full bg-canvas flex items-center justify-center px-4 py-12'>
      <div className='w-full max-w-sm'>
        <div className='flex justify-center mb-10'>
          <Logo size='lg' align='center' />
        </div>
        <div className='bg-white rounded-2xl p-6 space-y-4'>
          <p className='text-3xl font-medium tracking-tight text-slate-900 tabular-nums'>404</p>
          <div>
            <h1 className='text-sm font-semibold text-slate-800'>Page not found</h1>
            <p className='text-sm text-slate-500 mt-1'>Please check the URL in the address bar and try again.</p>
          </div>
          <a
            href='/'
            className='w-full py-3 bg-blue-600 text-white rounded-xl text-sm font-semibold hover:bg-blue-700 transition-colors flex items-center justify-center gap-2'
          >
            Go back home
          </a>
        </div>
      </div>
    </div>
  );
}

export default NotFoundLayout;
